import { nativeEnum } from 'zod';

import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import { Earning_Mechanism_Product_Counting_Rounding_Strategy } from '@occc/graphql';

export const ProductCountingRoundStrategySchema = nativeEnum(
  Earning_Mechanism_Product_Counting_Rounding_Strategy,
  {
    required_error: IS_REQUIRED,
  },
);
